<template>
  <div>
    <Error :error="error" />
  </div>
</template>

<script>
import Error from "@/components/Utilities/Error";

export default {
  components: {
    Error
  },
  props: { error: { type: String, default: "404" }}
};
</script>
